import http from "../http-common";

class DashboardService {

    getUnresolvedTicketCount(user_id_asking) {
        return http.get(`/dashboard?userIdAsking=${user_id_asking}`, {
            withCredentials: true
        });
    }

    getUnresolvedTicketsByPriority(user_id_asking, tenant) {
        return http.get(`/dashboard?userIdAsking=${user_id_asking}&tenant=${tenant}`, {
            withCredentials: true
        });
    }

    getWidgets(user_id_asking, dashboardName) {
        return http.get(`/dashboard/getwidgets?associatedUserId=${user_id_asking}&dashboardName=${dashboardName}`, {
            withCredentials: true
        });
    }

    setWidgets(user_id_asking, widgetsData, dashboardName) {
        return http.post(`/dashboard/setwidgets?associatedUserId=${user_id_asking}&dashboardName=${dashboardName}`, widgetsData, {
            withCredentials: true
        });
    }

    getTicketsIndividualMonth(user_id_asking, tenant_id, year, month, timezone_adjustment_factor) {
        return http.get(`/dashboard/ticketsByMonthWidget?userIdAsking=${user_id_asking}&tenantId=${tenant_id}&year=${year}&month=${month}&timezoneAdjustmentFactor=${timezone_adjustment_factor}`, {
            withCredentials: true
        });
    }

    getTicketsByDayOfWeek(user_id_asking, tenant_id, month, year, timezone_adjustment_factor) {
        return http.get(`/dashboard/ticketsByDayOfWeek?userIdAsking=${user_id_asking}&tenantId=${tenant_id}&month=${month}&year=${year}&timezoneAdjustmentFactor=${timezone_adjustment_factor}`, {
            withCredentials: true
        });
    }

    getTicketsByHourOfDay(user_id_asking, tenant_id, day, month, year, timezone_adjustment_factor) {
        return http.get(`/dashboard/ticketsByHourOfDay?userIdAsking=${user_id_asking}&tenantId=${tenant_id}&day=${day}&month=${month}&year=${year}&timezoneAdjustmentFactor=${timezone_adjustment_factor}`, {
            withCredentials: true
        });
    }

    getTicketsBySLA(user_id_asking, tenant_id, day, month, year, timezone_adjustment_factor) {
        return http.get(`/dashboard/ticketsBySLA?userIdAsking=${user_id_asking}&tenantId=${tenant_id}&day=${day}&month=${month}&year=${year}&timezoneAdjustmentFactor=${timezone_adjustment_factor}`, {
            withCredentials: true
        });
    }

    getSLAPerformance(user_id_asking, tenant_id, day, month, year, timezone_adjustment_factor) {
        return http.get(`/dashboard/slaPerformance?userIdAsking=${user_id_asking}&tenantId=${tenant_id}&day=${day}&month=${month}&year=${year}&timezoneAdjustmentFactor=${timezone_adjustment_factor}`, {
            withCredentials: true
        });
    }

    getOpenTicketCountByTech(user_id_asking, tenant_id) {
        return http.get(`/dashboard/openTicketCountByTech?userIdAsking=${user_id_asking}&tenantId=${tenant_id}`, {
            withCredentials: true
        });
    }

}


export default new DashboardService();